// Hook odpowiedzialny za pobranie listy pozycji zamówienia

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest
} from 'api/types';

export interface IOrderPositionListItem {
  id: number;
  order_id: number;
  order_symbol: string;
  order_created_at: string;
  product_unit_id: number;
  product_id: number;
  product_name: string;
  product_id_external: string;
  unit_shortcut: string;
  quantity: number;
  price_net: number;
  price_gross: number;
  value_net: number;
  value_gross: number;
  has_complaint: boolean;
  complaints_count: number;
  name: string;
  description: string | null;
}

// parametry requestu do api
export type IRequest = IPaginationRequest & ISearchRequest;

// typ zwracanych danych
type IResponse = IPaginationResponse<IOrderPositionListItem>;

const getOrderPositionsWithComplaints = ( params?: IRequest): Promise<IResponse> =>
  axios.get(`/return-complain/order-positions-with-complaints`, { params });

export const useGetOrderPositionsWithComplaints = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['order-positions-with-complaints', params],
    () => getOrderPositionsWithComplaints(params),
    options
  );
